module.exports = __webpack_public_path__ + "static/media/Moringa-collecting---Mike-goldwater-Alamy.0effd74f.jpg";